export default __webpack_public_path__ + "afr_dark.cf4ae118.svg";